import { isSlackUrl } from './is-slack-url';

/**
 * Strips query parameters from Slack URLs to help SmartCard resolve them better.
 */
export const stripSlackQueryParams = (url: string): string => {
	if (isSlackUrl(url)) {
		const urlObj = new URL(url);
		return `${urlObj.protocol}//${urlObj.hostname}${urlObj.pathname}`;
	}
	return url;
};
